var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 106,
    viewBox: "0 0 126 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.543 80.3109C102.543 80.3109 90.9441 103.678 61.9044 104.547C32.8646 105.416 18.9116 77.5312 18.9116 77.5312C18.9116 77.5312 -26.8167 0.566772 63.3547 0.566772C154.573 0.566772 102.543 80.3109 102.543 80.3109Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22617_511",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 111,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.045 80.5352C102.045 80.5352 90.441 104.004 61.3882 104.877C32.3354 105.749 18.376 77.7433 18.376 77.7433C18.376 77.7433 -27.3729 0.443604 62.8392 0.443604C154.098 0.443604 102.045 80.5352 102.045 80.5352Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22617_511)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9981 74.942C82.6349 69.843 86.5498 62.7389 88.5905 56.0055C93.622 43.0176 84.1682 29.3364 70.0404 25.0548C55.9126 20.7731 41.9134 30.2217 38.6832 40.8803C36.4406 48.28 36.8602 56.9231 38.3262 64.2526C38.9778 67.5108 40.9519 70.7086 43.9485 73.4366C42.4944 73.9442 41.6358 75.2179 41.9054 77.6974C42.4603 82.8007 41.541 87.9267 40.603 93.1575C39.1035 101.519 37.556 110.148 41.9053 119.38C62.4953 124.44 74.8674 123.393 80.2766 119.38C86.0362 115.107 84.1275 99.4468 82.9042 89.4097C82.5258 86.3048 82.2129 83.7379 82.2129 82.2126C82.2129 78.8989 79.9573 75.9381 77.9981 74.942Z",
    fill: "url(#paint0_linear_22617_511)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8952 72.2232C53.8746 72.214 53.8545 72.2049 53.8349 72.196C53.8553 72.2023 53.8754 72.2114 53.8952 72.2232C56.524 73.397 68.3273 77.2012 70.4128 76.0935C73.0403 74.6979 67.0135 81.8591 65.1049 82.3956C61.7376 83.3419 60.4947 82.8075 58.2372 81.2274C55.2703 79.1508 54.8158 72.7706 53.8952 72.2232Z",
    fill: "#113A51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4947 56.5335C86.3743 54.2264 86.3393 54.5868 88.0375 49.9631C89.7357 45.3393 83.4908 41.519 80.0871 38.1855C76.6834 34.852 75.1716 31.599 65.6193 30.7467C56.0669 29.8945 54.4549 33.581 51.3378 35.1789C48.2207 36.7768 44.3875 33.708 40.515 43.7558C38.6825 49.2655 40.6819 61.8414 44.6573 67.7302C48.6326 73.619 54.88 76.4156 61.5137 77.2106C66.7771 77.8414 75.6455 75.2472 81.4413 67.165C83.2277 64.6739 84.2147 59.8908 85.4947 56.5335Z",
    fill: "#113A51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0175 58.245C82.7466 60.2338 78.8554 62.6524 74.8367 62.1911C71.7858 61.8409 70.6286 60.5948 69.4528 59.3287C68.2385 58.021 67.0042 56.6919 63.6431 56.3061C60.3002 55.9223 58.8653 56.9322 57.4458 57.9314C56.0561 58.9095 54.681 59.8773 51.5449 59.5173C46.473 58.935 41.6935 55.3197 40.0756 53.6006C39.9733 54.4914 39.958 55.6769 40.0876 57.0482C41.5672 62.3609 44.3377 68.1335 47.3997 71.2728C52.3675 76.366 59.0317 78.0139 65.7228 77.6235C71.0319 77.3137 79.3298 73.1924 83.6224 64.2126C84.3564 62.677 84.7226 60.4905 85.0175 58.245Z",
    fill: "#0193D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.5675,
    cy: 48.2092,
    rx: 4.22724,
    ry: 5.46215,
    transform: "rotate(1.77097 53.5675 48.2092)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.5479,
    cy: 50.6952,
    rx: 4.0207,
    ry: 5.19528,
    transform: "rotate(15.2347 75.5479 50.6952)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 85.4999C16 82.9999 12.5 83.9999 16.5 90C20.3998 95.8497 28.5 103.5 34.9999 103.5C45 94.5 41.4999 80.4999 41.9999 75.9999C32.5 75.9999 31.9999 93.1487 29.7765 93.1487C27.5531 93.1487 23.9998 87.9998 19.9999 85.4999Z",
    fill: "#113A51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 82C109.279 79.1771 114.489 79.6891 111 86C107.599 92.1529 98 98.5 88.5 99C78.5 99.5263 86.9999 81 77.5 75.5002C90.9999 59.5 89.0934 87.2453 92 86C94.9066 84.7548 101.721 84.823 105.5 82Z",
    fill: "#113A51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5409 83.5362C12.8457 81.9125 8.58043 85.0258 5.89003 87.2027C5.89008 90.3603 7.8069 95.0241 11.9014 96.2747C14.1588 96.9641 16.0734 95.1201 17.8157 92.1801C19.9353 88.6035 21.4552 85.8109 15.5409 83.5362Z",
    fill: "#113A51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28426 82.0314C7.73396 80.9744 6.51655 81.2778 6.71962 83.8535C7.03366 85.9331 9.90759 87.0664 11.9696 87.7271C13.3131 87.5085 14.1276 86.194 14.1971 84.1824C14.2816 81.7351 11.2221 83.3526 9.28426 82.0314Z",
    fill: "#113A51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39678 91.2326C0.298904 89.2397 3.58405 88.4529 5.58033 87.1777C7.55755 86.0529 8.17366 88.4241 7.04183 90.1148C5.91 91.8055 2.48119 93.201 1.39678 91.2326Z",
    fill: "#113A51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25728 96.2747C1.91716 94.436 5.85413 92.7481 7.67392 91.2316C9.49374 89.8668 10.4036 92.1415 9.49367 93.9613C8.58378 95.7811 4.58094 98.0908 3.25728 96.2747Z",
    fill: "#113A51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49736 98.409C5.89922 96.7896 9.41682 95.7696 10.9914 93.9999C12.5885 92.3801 13.2559 93.8646 12.6262 95.7992C11.9964 97.7339 9.07589 100.009 7.49736 98.409Z",
    fill: "#113A51"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.81 79.9854C112.772 78.2009 117.459 81.6225 120.416 84.015C120.416 87.4853 118.31 92.6109 113.81 93.9854C111.329 94.7431 109.224 92.7164 107.31 89.4854C104.98 85.5545 103.31 82.4854 109.81 79.9854Z",
    fill: "#113A51"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.686 78.3317C118.39 77.17 119.728 77.5035 119.504 80.3343C119.159 82.6198 116.001 83.8654 113.735 84.5915C112.258 84.3512 111.363 82.9065 111.287 80.6957C111.194 78.0061 114.556 79.7838 116.686 78.3317Z",
    fill: "#113A51"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.354 88.444C126.561 86.2538 122.951 85.3891 120.757 83.9876C118.584 82.7514 117.906 85.3574 119.15 87.2156C120.394 89.0737 124.163 90.6074 125.354 88.444Z",
    fill: "#113A51"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.31 93.9854C124.783 91.9645 120.456 90.1096 118.456 88.4429C116.456 86.9429 115.456 89.4429 116.456 91.4429C117.456 93.4429 121.855 95.9814 123.31 93.9854Z",
    fill: "#113A51"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.65 96.3312C120.406 94.5513 116.54 93.4304 114.81 91.4854C113.054 89.7052 112.321 91.3367 113.013 93.4629C113.705 95.5892 116.915 98.0892 118.65 96.3312Z",
    fill: "#113A51"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22617_511",
    x1: 63.5359,
    y1: 24,
    x2: 63.5359,
    y2: 122.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataLight);
export default __webpack_public_path__ + "static/media/noData_light.04c33e5f7fc24c2fce1925d7a0b96833.svg";
export { ForwardRef as ReactComponent };